module.exports = __webpack_public_path__ + "img/popularize08.448f3847.png";